export default {
  data () {
    return {
      tableCols: [ // 节目集发布表头
        { type: 'selection', width: 55 },
        { prop: 'name', label: '标题' },
        { prop: 'category', label: '一级分类' },
        { prop: 'sndCategory', label: '二级分类' },
        { prop: 'seriesNo', label: '集号' },
        {
          prop: 'auditState',
          label: '状态',
          formatter: function (row, column) {
            let auditStateText = ''
            switch (row.auditState) {
              case 'AUDIT_EXEMPT':
                auditStateText = '免审核'
                break
              case 'AUDIT_ING':
                auditStateText = '待初审'
                break
              case 'AUDIT_PASS':
                auditStateText = '初审通过'
                break
              case 'AUDIT_NO_PASS':
                auditStateText = '初审驳回'
                break
              case 'AUDIT_NON':
                auditStateText = '未审核'
                break
              case 'UNIFORM_AUDIT_NON':
                auditStateText = '待终审'
                break
              case 'UNIFORM_AUDIT_ING':
                auditStateText = '终审中'
                break
              case 'UNIFORM_AUDIT_PASS':
                auditStateText = '终审通过'
                break
              case 'UNIFORM_AUDIT_NO_PASS':
                auditStateText = '终审未通过'
                break
              case 'UNIFORM_AUDIT_OFFLINE':
                auditStateText = '终审下线'
                break
            }
            return auditStateText
          }
        },
        { prop: 'updateBy', label: '操作人' },
        { prop: 'updateTime', label: '更新时间', type: 'slot' }
      ]
    }
  },
  computed: {
    searchData () {
      return [
        { prop: 'name', type: 'input', label: '标题：', placeholder: '请输入', clearable: true, labelWidth: '60px', col: [3, 3, 3] },
        {
          prop: 'category',
          label: '一级分类',
          type: 'select',
          options: this.categoryList,
          change: this.selectChangeCategory
        },
        {
          prop: 'sndCategory',
          label: '二级分类',
          type: 'select',
          disabled: false, // this.sndCategoryDisabled,
          options: this.sndCategoryList
        },
        {
          prop: 'updateTimeArr',
          label: '更新时间：',
          type: 'slot'
        },
        { prop: 'search', type: 'slot', label: '', col: [3, 3, 3] }
      ]
    }
  }
}
